import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie';
import HearingService from '../services/HearingService';
import AuthService from '../services/Authservice';
import NoteTaskService from '../services/NoteTaskService';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        user: {
            userName: '',
            application: '',
            userEmailAddress: '',
            applications: [],
            securityRoles: [],
            token: '',
        },
        isLoading: false,
        isHearingSupervisor: false,
        applicationMessages: {
            class: 'error',
            multiline: false,
            messages: []
        },
        refData: [],
        selectedGrid: {
            id: '',
            name: ''
        },
        selectedRep: '',
        searchCriteria: [{ text: 'Claim #', value: '', id: 'claimNumber' }, { text: 'Policy #', value: '', id: 'policyNumber' }, { text: 'Employer Name', value: '', id: 'employerName' }, { text: 'Claimant Name', placeholder: 'LastName, FirstName', value: '', id: 'claimantName' }],
        searchResults: {}
    },
    mutations: {
        removeUserToken(state) {
            state.user = { userName: '', token: '', userEmailAddress: '', application: '', applications: [], securityRoles: [] };
            state.applicationMessages = {
                class: 'error',
                multiline: false,
                messages: []
            };
        },
        createUser(state, userData) {
            state.user = userData.userData;
            state.user.applications = userData.userApplications;
        },
        setApplication(state, app) {
            state.user.application = app;
        },
        setUserSecurityRoles(state, roles) {
            state.user.securityRoles = roles;
        },
        updateIsLoading(state, loading) {
            state.isLoading = loading;
        },
        addMessages(state, messages) {
            state.applicationMessages = messages;
        },
        clearMessages(state) {
            state.applicationMessages = {
                class: 'error',
                multiline: false,
                messages: []
            };
        },
        setRefData(state, data) {
            state.refData = data;
        },
        setSelectedGrid(state, data) {
            state.selectedGrid = data;
        },
        setSelectedHearingRep(state, data) {
            state.selectedRep = data;
        },
        storeSearchCriteria(state, data) {
            state.searchCriteria = data;
        },
        storeSearchResults(state, data) {
            state.searchResults = data;
        },
        updateIsHearingSupervisor(state, loading) {
            state.isHearingSupervisor = loading;
        },
        clearSearchCriteria(state) {
            state.searchCriteria = [{ text: 'Claim #', value: '', id: 'claimNumber' }, { text: 'Policy #', value: '', id: 'policyNumber' },
            { text: 'Employer Name', value: '', id: 'employerName' }, { text: 'Claimant Name', placeholder: 'LastName, FirstName', value: '', id: 'claimantName' }];
            state.searchResults = {};
        }
    },
    getters: {
        isAuthenticated: state => {
            return state.user.token != '';
        },
        userEmail: state => {
            return state.user.userEmailAddress;
        },
        userName: state => {
            return state.user.userName;
        },
        userToken: state => {
            return state.user.token;
        },
        userApplications: state => {
            return state.user.applications;
        },
        hasApplicationMessages: state => {
            return state.applicationMessages != null && state.applicationMessages.messages.length > 0;
        },
        existingSearchCriteria: state => {
            return state.searchCriteria;
        },
        isHearingSupervisor: state => {
            return state.isHearingSupervisor;
        },
        existingSearchResults: state => {
            return state.searchResults;
        }
    },
    actions: {
        login: function (context, userData) {
            context.commit('clearSearchCriteria');
            context.commit('createUser', userData);
            context.state.isHearingSupervisor = false;
        },
        logout: function (context) {
            context.commit('setApplication', '');
            context.commit('removeUserToken');
            localStorage.clear();
        },
        setApplicationName: function (context, app) {
            if (app != '')
                app = ' - ' + app;
            context.commit('setApplication', app);
        },
        validateAccess: function (context, app) {
            let apps = context.getters.userApplications;

            let test = apps.find((el: any) => {
                return el.Path == app;
            });

            return test != undefined;
        },
        isLoading: function (context, loading) {
            if (context.state.isLoading != loading)
                context.commit('updateIsLoading', loading);
        },
        addApplicationMessages: function (context, messages) {
            context.commit('addMessages', messages);
        },
        clearMessages: function (context) {
            context.commit('clearMessages');
        },
        getHearingRep: function (context, data) {
            if (data != null) {
                let stringData = JSON.stringify(data);
                window.localStorage.setItem('selectedHearingRep', stringData);

                context.commit('setSelectedHearingRep', data);
            }
            else if (data === undefined && window.localStorage.getItem("selectedHearingRep") != null) {
                let localData: string | null = window.localStorage.getItem('selectedHearingRep');
                var actualData = localData != null ? JSON.parse(localData) : null;

                context.commit('setSelectedHearingRep', actualData);
            }
            else if (data === undefined && window.localStorage.getItem("selectedHearingRep") == null)
                context.commit('setSelectedHearingRep', "");
            else
                console.log('data already exists in state.selectedHearingRep - do nothing');
        },
        getSelectedGrid: function (context, data) {
            if (data != null) {
                let stringData = JSON.stringify(data);
                window.localStorage.setItem('selectedGrid', stringData);

                context.commit('setSelectedGrid', data);
            }
            else if (data === undefined && window.localStorage.getItem("selectedGrid") != null) {
                let localData: string | null = window.localStorage.getItem('selectedGrid');
                var actualData = localData != null ? JSON.parse(localData) : null;

                context.commit('setSelectedGrid', actualData);
            }
            else if (data === undefined && window.localStorage.getItem("selectedGrid") == null)
                context.commit('setSelectedGrid', "");
            else
                console.log('data already exists in state.selectedGrid - do nothing');
        },
        setSelectedGrid: function (context, data) {
            let stringData = JSON.stringify(data);
            window.localStorage.setItem('selectedGrid', stringData);

            context.commit('setSelectedGrid', data);
        },
        setSelectedHearingRep: function (context, data) {
            let stringData = JSON.stringify(data);
            window.localStorage.setItem('selectedHearingRep', stringData);

            context.commit('setSelectedGrid', data);
        },
        loadSecurityRoles: function (context) {
            let service = new AuthService();
            if (window.localStorage.getItem('secRoles') === null) {
                //console.log('calling api to load user security roles - local storage empty');
                return service.GetUserSecurity()
                    .then((resp) => {

                        let stringData = JSON.stringify(resp.data);
                        if (stringData.indexOf("JT_CMI_HrgAdm_HrgAdmSpvr") > 0 || stringData.indexOf("JT_CMI_SF_OpsMgr1") > 0) {
                            context.state.isHearingSupervisor = true;
                        }
                        window.localStorage.setItem('secRoles', stringData);

                        context.commit('setUserSecurityRoles', resp.data);
                    });
            }
            else if (context.state.refData == null || (context.state.refData != null && context.state.refData.length == 0)) {
                //console.log('loading sec user data from localStorage');
                let data: string | null = window.localStorage.getItem('secRoles');
                var actualData = data != null ? JSON.parse(data) : null;

                context.commit('setUserSecurityRoles', actualData);
            }
            else {
                console.log('data already exists in state.secRoles - do nothing');
            }
        },
        loadRefData: function (context) {
            let service = new HearingService();
            let noteService = new NoteTaskService();
            if (window.localStorage.getItem("refData") === null) {
                // console.log('calling api to load ref data - localStorage is empty');
                return Promise.all([service.GetHearingAttorneys(), service.GetHearingOfficers(), service.GetHearingDocketTypes(), service.GetHearingOutcomes(), service.GetHearingLevels()
                    , service.GetHearingPendedReasons(), service.GetHearingIssues(), service.GetHearingComments(), service.GetHearingLocations(), noteService.GetHearingReps(), service.GetHearingOfficerTypes()])
                    .then((responses) => {
                        let data = {
                            attorneyOptions: [],
                            hearingOfficers: [],
                            docketTypes: [],
                            outcomeOptions: [],
                            hearingLevels: [],
                            pendedReasons: [],
                            issues: [],
                            comments: [],
                            cities: [],
                            hearingReps: [],
                            hearingOfficerTypes:[]
                        };

                        data.attorneyOptions = responses[0].data;
                        data.hearingOfficers = responses[1].data;
                        data.docketTypes = responses[2].data;
                        data.outcomeOptions = responses[3].data;
                        data.hearingLevels = responses[4].data;
                        data.pendedReasons = responses[5].data;
                        data.issues = responses[6].data;
                        data.comments = responses[7].data;
                        data.cities = responses[8].data;
                        data.hearingReps = responses[9].data;
                        data.hearingOfficerTypes = responses[10].data;

                        let stringData = JSON.stringify(data);  //local storage can only store strings

                        window.localStorage.setItem('refData', stringData);

                        context.commit('setRefData', data);
                    })
            }
            else if (context.state.refData == null || (context.state.refData != null && context.state.refData.length == 0)) {
                //console.log('loading ref data from localStorage');
                let data: string | null = window.localStorage.getItem('refData');
                var actualData = data != null ? JSON.parse(data) : null;

                context.commit('setRefData', actualData);
            }
            else {
                console.log('data already exists in state.refData - do nothing');
            }
        },
        setSearchCriteria: function (context, data) {
            context.commit('storeSearchCriteria', data.options);
            context.commit('storeSearchResults', data.results);
        },
        clearSearchCriteria: function (context) {
            context.commit('clearSearchCriteria');
        }
    },
    plugins: [createPersistedState({
        key: 'teamportal',
        paths: ['user'],
        storage: {
            getItem: key => Cookies.get(key),
            setItem: (key, value) => Cookies.set(key, value, { expires: 3 }),
            removeItem: key => Cookies.remove(key)
        }
    })]
})

export default store


// WEBPACK FOOTER //
// ./ClientApp/src/store/index.ts